import { getEnvParam } from 'env'
import { sendEncrypted } from 'pUtils'

import client, { clientForLanding, restClient } from 'myNet'
import Ngql, { setDefaultClient } from 'gql/ninegql'
import NQuery from './query'

setDefaultClient(client)

interface WorkspaceResponse {
  code: number
  [key: string]: any
}

interface MyInfoData {
  id: string
  email: string
  displayName: string
  avatarUrl: string
}

interface MyInfoResponse {
  data: {
    me: MyInfoData
    serverType: string
  }
}

interface MyInfo {
  id: string
  email: string
  display_name: string
  avatar_url: string
  serverType: string
}

interface WorkspaceInfo {
  [key: string]: any
}

interface WorkspaceConfigData {
  config: any
}

interface WorkspaceConfigResponse {
  data: {
    code: number
    message?: string
    data: WorkspaceConfigData
  }
}

interface UpdateDeviceOptions {
  vars: any
}

export function getWorkspaceList(): Promise<WorkspaceResponse> {
  const promise = new Promise<WorkspaceResponse>((resolve, reject) => {
    const email = getEnvParam('userEmail')

    const params = {
      email,
    }

    sendEncrypted(
      '/payment/workspace/',
      params,
      (res: WorkspaceResponse) => {
        if (res.code === 200) {
          resolve(res)
        } else {
          reject(res)
        }
      },
      (ex: any) => {
        reject(ex)
      },
    )
  })

  return promise
}

export function getMyInfo(): Promise<MyInfo> {
  const promise = new Promise<MyInfo>((resolve, reject) => {
    Ngql.GQLObj(NQuery.queryMyAccount as any, {
      name: 'myInfo',
      useUI: false,
    })
      .query({}, clientForLanding)
      .then((res: MyInfoResponse) => {
        console.log(' queryMyAccount - ', res)
        const { id, email, displayName, avatarUrl } = res.data.me
        const { serverType } = res.data
        resolve({
          id,
          email,
          display_name: displayName,
          avatar_url: avatarUrl,
          serverType,
        })
      })
      .catch((err: any) => {
        reject(err)
      })

    // const email = getEnvParam('userEmail')

    // checkMember([email], true)
    //   .then((res) => {
    //     console.log('checkMember - ', res)

    //     if (res.data.code === 200 && res.data.data.length > 0) {
    //       const myData = res.data.data[0]
    //       resolve(myData)
    //     } else {
    //       resolve({
    //         email,
    //       })
    //     }
    //   })
    //   .catch((err) => {
    //     reject(err)
    //   })
  })

  return promise
}

export function getUserExists(): Promise<boolean> {
  const promise = new Promise<boolean>((resolve, reject) => {
    Ngql.GQLObj(NQuery.queryUserExists as any, {
      name: 'userExists',
      useUI: false,
    })
      .query({}, clientForLanding)
      .then((res: any) => {
        console.log(' queryUserExists - ', res)
        resolve(res.data.userExists)
      })
      .catch((err: any) => {
        reject(err)
      })
  })

  return promise
}

export function getWorkspaceInfo(workspaceId: string): Promise<WorkspaceInfo> {
  const promise = new Promise<WorkspaceInfo>((resolve, reject) => {
    // Ngql.GQLObj(NQuery.queryAllWorkspaces, {
    //   name: 'allWorkspaces',
    //   useUI: false,
    // })
    //   .query({ variables: { id: workspaceId } })
    //   .then((res0) => {
    //     console.log(' allWorkspaces - ', res0)
    //     if (res0.data.allWorkspaces != null && res0.data.allWorkspaces.edges.length > 0) {
    //       Ngql.GQLObj(NQuery.queryGetWorkspaceInfo, {
    //         name: 'workspaceInfo',
    //         useUI: false,
    //       })
    //         .query({ variables: { workspaceId } }, clientForLanding)
    //         .then((res) => {
    //           console.log(' getWorkspaceInfo - ', res)
    //           const workspaceInfo = {
    //             ...res.data.getWorkspaceInfo,
    //             workspaceGid: res0.data.allWorkspaces.edges[0].node.id,
    //           }
    //           resolve(workspaceInfo)
    //         })
    //         .catch((err) => {
    //           reject(err)
    //         })
    //     }
    //   })
    //   .catch((err) => {
    //     reject(err)
    //   })
    Ngql.GQLObj(NQuery.queryGetWorkspaceInfo as any, {
      name: 'workspaceInfo',
      useUI: false,
    })
      .query({ variables: { workspaceId } }, clientForLanding)
      .then((res: any) => {
        console.log(' getWorkspaceInfo - ', res)
        const workspaceInfo: WorkspaceInfo = {
          ...res.data.getWorkspaceInfo,
        }
        resolve(workspaceInfo)
      })
      .catch((err: any) => {
        reject(err)
      })
  })

  return promise
}

export function getWorkspaceConfig(workspaceId: string): Promise<any> {
  const promise = new Promise<any>((resolve, reject) => {
    const params = {
      workspace_id: workspaceId,
    }

    restClient
      .post('/provisioning/workspace', params)
      .then((res: WorkspaceConfigResponse) => {
        console.log(' getWorkspaceConfig - ', res)
        const { data, code, message } = res.data
        if (code === 200) {
          resolve(data.config)
        } else {
          reject(new Error(message || String(code)))
        }
      })
      .catch((err: any) => {
        reject(err)
      })
  })

  return promise
}

export function mutateUpdateDevice(options: UpdateDeviceOptions): Promise<any> {
  return Ngql.GQLObj(NQuery.mutationUpdateDevice as any, { vars: options.vars }).mutate(
    {},
    clientForLanding,
  )
}

const defaultData = {
  getWorkspaceList,
  getMyInfo,
  getWorkspaceInfo,
  mutateUpdateDevice,
}

export default defaultData
